module.exports = __webpack_public_path__ + "img/8valvulas.d74438eb.jpg";